import React from 'react'

import {
  FieldSpec,
  PaginatedTable,
  RelatedLinkedField,
  UnitLocUnitField,
  ValueField,
} from 'src/components/Table'
import {ListTableProps} from './types'

const fieldOptions: {[key: string]: FieldSpec} = {
  sku: {id: 'sku', label: 'SKU', renderer: RelatedLinkedField(ValueField, 'sku')},
  product: {id: 'sku.product', label: 'Product', renderer: RelatedLinkedField(ValueField, 'name')},
  batch: {id: 'batch', label: 'Batch', ordering: 'client_uid', renderer: RelatedLinkedField(ValueField, 'name')},
  container: {id: 'container', label: 'Container', renderer: RelatedLinkedField(ValueField, 'name')},
  numUnits: {id: 'numUnits', label: 'Quantity', renderer: UnitLocUnitField},
}

export const AuditResultUnitLocListTable = (props: ListTableProps) => {
  const { paginator, fields, exportConfig, title='Units', } = props

  return (
    <>
      <PaginatedTable
        title={title}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
